import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Icon } from '../Icon';

import { BreadcrumbItemProps } from './types';

interface BreadcrumbsProps {
  items: BreadcrumbItemProps[];
  testId?: string;
}

export const Breadcrumbs = ({ items, testId }: BreadcrumbsProps) => {
  return (
    <BreadcrumbsStyled data-testid={testId}>
      {items.map(({ to, label }, idx) => {
        const isLast = idx >= items.length - 1;

        return isLast ? (
          <LastItemStyled key={idx}>{label}</LastItemStyled>
        ) : (
          <Fragment key={idx}>
            <LinkStyled to={to}>{label}</LinkStyled>
            <IconStyled name="chevronRight" />
          </Fragment>
        );
      })}
    </BreadcrumbsStyled>
  );
};

const BreadcrumbsStyled = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const TextStyled = css`
  font-family: ${({ theme: { fonts } }) => fonts?.openSans};
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0;
  text-transform: capitalize;
  text-decoration: none;
`;

const LinkStyled = styled(Link)`
  ${TextStyled}
  color: ${({ theme: { colors } }) => colors?.breadcrumbGray};
`;

const LastItemStyled = styled.span`
  ${TextStyled}
  color: ${({ theme: { colors } }) => colors?.breadcrumbBlack};
`;

const IconStyled = styled(Icon)`
  ${TextStyled}
  margin: 0 5px;
  color: ${({ theme: { colors } }) => colors?.breadcrumbGray};
  width: 14px;
  height: 14px;
`;
